import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_pl.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.pl.js'
import 'moment/locale/pl.js'
import './translations.tc.pl.js'

$.fn.datepicker.defaults.language = 'pl'

I18n.defaultLocale = 'pl'
I18n.locale = 'pl'

export default App
